import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize, Subject, takeUntil } from 'rxjs';
import { AuxiliarService } from '../../../services/auxiliar.service';
import { NGXLogger } from 'ngx-logger';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { passwordValidator } from '../../../utils/validators/passwordValidator';
import { Employee } from '../../../models/employee';
import { EmployeeService } from '../../../services/employee.service';

@Component({
  selector: 'app-change-password-drawer',
  standalone: false,
  templateUrl: './change-password-drawer.component.html',
  styleUrl: './change-password-drawer.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ChangePasswordDrawerComponent implements OnInit, OnDestroy {
  @Input() employee: Employee;

  private destroy$: Subject<boolean> = new Subject<boolean>();
  public employees: Employee[] = [];
  public form: FormGroup;
  public loading: boolean;
  public loadingEmployees: boolean;

  get f(): { [index: string]: any } {
    return this.form.controls;
  }

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private auxiliarService: AuxiliarService,
    private logger: NGXLogger,
    private formBuilder: FormBuilder,
    private employeeService: EmployeeService,
  ){}

  async ngOnInit() {
    this.loadForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private loadForm(): void {
    this.form = this.formBuilder.group({
      password: ['', [Validators.required]],
      passwordRepeat: ['', []],
    });

    this.f['passwordRepeat'].setValidators([Validators.required, passwordValidator(this.f['password'])]);
  }

  public save(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.loading = true;
      if (this.employee){
        // employee's password
        this.employeeService.changeEmployeePassword(this.employee, this.f['password'].value).pipe(
          finalize(() => this.loading = false),
          takeUntil(this.destroy$)
        ).subscribe({
          next: (res: any) => {
            this.logger.debug('[authService] changePasswordOthers res: ', res);
            this.auxiliarService.toast(this.translate.instant('success.change-password'), 'success');
            this.auxiliarService.closeDrawer();
          },
          error: (err: any) => {
            this.logger.error('[authService] changePasswordOthers err:', err);
            this.auxiliarService.toast(this.translate.instant('error.change-password'), 'error');
          }
        });
      } else {
        // my password
        this.authService.changePassword(this.f['password'].value).pipe(
          finalize(() => this.loading = false),
          takeUntil(this.destroy$)
        ).subscribe({
          next: (res: any) => {
            this.logger.debug('[authService] changePassword res: ', res);
            this.auxiliarService.toast(this.translate.instant('success.change-password'), 'success');
            this.auxiliarService.closeDrawer();
          },
          error: (err: any) => {
            this.logger.error('[authService] changePassword err:', err);
            this.auxiliarService.toast(this.translate.instant('error.change-password'), 'error');
          }
        });
      }
    }
  }

  public cancel(): void {
    this.auxiliarService.closeDrawer();
  }
}
